module.exports = __webpack_public_path__ + "static/media/onboardingNewUser.6457e1b3.png";